/* tslint:disable */
/* eslint-disable */
/**
 * Limber Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisteredPhysician
 */
export interface RegisteredPhysician {
    /**
     * 
     * @type {number}
     * @memberof RegisteredPhysician
     */
    organizationId: number;
    /**
     * 
     * @type {string}
     * @memberof RegisteredPhysician
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof RegisteredPhysician
     */
    password: string;
}

export function RegisteredPhysicianFromJSON(json: any): RegisteredPhysician {
    return RegisteredPhysicianFromJSONTyped(json, false);
}

export function RegisteredPhysicianFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisteredPhysician {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organizationId': json['organization-id'],
        'email': json['email'],
        'password': json['password'],
    };
}

export function RegisteredPhysicianToJSON(value?: RegisteredPhysician | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organization-id': value.organizationId,
        'email': value.email,
        'password': value.password,
    };
}


